// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q3b3","question":"styles_question__17U8p","description":"styles_description__3rlsY"};